<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button style="margin-left: 20px" type="primary" @click="exportList"
          >导出
        </el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["customerStockList"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }

    this.fetch();
  },
  mounted() {
    this.lists({
      request: {
        currentPage: 1,
        pageSize: 10
      }
    });
  },
  data() {
    return {
      loading: false,
      dataList: [],
      columns: [
        {
          title: "货主id",
          key: "customerId",
          align: "center"
        },
        {
          title: "商品料号",
          key: "itemNo",
          align: "center"
        },
        {
          title: "商品条码",
          key: "barcodes",
          align: "center"
        },
        {
          title: "商品名称",
          key: "declareName",
          align: "center"
        },
        {
          title: "账册库存数量",
          key: "stockCustomsNum",
          align: "center"
        },
        {
          title: "冻结数量",
          key: "stockFreezeNum",
          align: "center"
        }
      ],
      filterObj: {
        customerId: "",
        declareName: "",
        itemNo: ""
      },
      currentRow: []
    };
  },
  computed: {
    ...mapState("record", {
      list: "list"
    })
  },
  methods: {
    ...mapActions("record", [
      "lists",
      "edit",
      "import",
      "queryList",
      "preview",
      "customerExport"
    ]),
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          queryInfo: { ...filterParams },
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        }
      };
      this.queryList(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "备案名称",
              model: "declareName",
              type: type.INPUT
            },
            {
              label: "商品料号",
              model: "itemNo",
              type: type.INPUT
            },
            {
              label: "商品条码",
              model: "barcodes",
              type: type.INPUT
            }
          ]
        }
      ];
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    // 导出列表
    exportList(data) {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      this.customerExport({
        request: {
          queryInfo: { ...filterParams }
        }
      })
        .then(res => {
          this.loading = false;
          if (res.value) {
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.$router.push({ name: "download" });
              }
            });
          } else {
            this.$message.error("提交失败");
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("提交失败");
        });
    }
  }
};
</script>
